import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

export type StyledTextSize = 'xs' | 'small' | 'regular' | 'regular-plus' | 'large' | 'xl' | 'xxl'
export type ColorMode = 'gray' | 'black' | 'orange' | 'red' | 'green'
export type FontWeight = 'standard' | 'thin'

export const StyledText: FC<{
  children: ReactNode
  href?: string
  size?: StyledTextSize
  isDarkenedOnHover?: boolean
  isActive?: boolean
  colorMode?: ColorMode
  className?: string
  fontWeight?: FontWeight
  capitalize?: boolean
  block?: boolean
  marginBottom?: number
  marginRight?: number
  marginTop?: number
  marginLeft?: number
  noMargin?: boolean
  noPadding?: boolean
}> = ({
  children,
  size = 'regular',
  colorMode = '',
  className = '',
  fontWeight = 'standard',
  block,
  marginBottom = 0,
  marginRight = 0,
  marginTop = 0,
  marginLeft = 0,
  noMargin,
  noPadding,
  capitalize,
  isDarkenedOnHover,
  isActive,
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  const style: Record<string, number> = {
    marginBottom,
    marginRight,
    marginTop,
    marginLeft,
  }

  if (noPadding) style.padding = 0
  if (noMargin) style.margin = 0

  return (
    <span
      style={style}
      // todo: add the disabled mode
      className={`ui-styled-text ${className} ${whiteLabel} ${size} ${colorMode} ${isDarkenedOnHover ? 'is-darkened-on-hover' : ''} ${isActive ? 'active' : ''} ${fontWeight} ${capitalize ? 'capitalize' : ''} ${block ? 'block' : ''} `}
    >
      {children}
    </span>
  )
}
